import { FC } from "react";
import { CustomerDeleteActivityProps } from "./types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { CustomerActivityDelete } from "../types";

const CustomerDeleteActivity: FC<CustomerDeleteActivityProps> = ({
  activity,
  type,
  by,
  date,
}) => {
  const _activity = activity as CustomerActivityDelete;
  return (
    <>
      <ActivityTitle type={type}>حذف مشتری</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="نام مشتری"
          value={_activity.fullname}
        />
        <ActivityBodyInfo
          type={type}
          title="شماره تماس"
          value={_activity.phone}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default CustomerDeleteActivity;
